import {
  ADD_COLLABORATOR_CARD_KEY,
  ADD_VIDEO_TO_TEAM_CARD_KEY,
  CUSTOMIZE_BRANDING_CARD_KEY,
  PERSONAL_LIBRARY_INTRO_CARD,
  RECORD_VIDEO_CARD_KEY,
  SHARED_LIBRARY_INTRO_CARD,
  SHARE_VIDEO_CARD_KEY,
  TEAM_LIBRARY_INTRO_CARD,
} from 'constants/workspaceOnboarding';

import AddCollaboratorCard from './dashboard-onboarding-cards/collaborate/collab-add-collaborator-card';
import AddVideoToTeamCard from './dashboard-onboarding-cards/collaborate/collab-add-video-to-team-card';
import CustomizeBrandingCard from './dashboard-onboarding-cards/features/feature-customize-branding-card';
import ShareVideoCard from './dashboard-onboarding-cards/how-to-use/how-share-video-card';
import RecordVideoCard, {
  filterFunction as recordVideoCardFilterFunction,
} from './dashboard-onboarding-cards/how-to-use/how-record-video-card';

export const mapCardKeytoComponent = {
  [ADD_COLLABORATOR_CARD_KEY]: AddCollaboratorCard,
  [ADD_VIDEO_TO_TEAM_CARD_KEY]: AddVideoToTeamCard,
  [CUSTOMIZE_BRANDING_CARD_KEY]: CustomizeBrandingCard,
  [RECORD_VIDEO_CARD_KEY]: RecordVideoCard,
  [SHARE_VIDEO_CARD_KEY]: ShareVideoCard,
};

export const mapCardKeyToCustomFilterFunctions = {
  [RECORD_VIDEO_CARD_KEY]: recordVideoCardFilterFunction,
};

export const COMPACT_ONBOARDING_INTRO_CARDS = new Set([
  PERSONAL_LIBRARY_INTRO_CARD,
  TEAM_LIBRARY_INTRO_CARD,
  SHARED_LIBRARY_INTRO_CARD,
]);
